import isEmpty from 'lodash/isEmpty';

const nonFoodPhysicalPackaging = [
  'factsPanelCheck',
  'countryOfOrigin',
  'kosher',
  'productContainsBioengineeredIngredients',
  'productPackagingPFASDeclaration',
  'activeIngredientListOTC',
  'usesOTC',
  'warningsOTC',
  'directionsOTC',
  'otherInformationOTC',
  'inactiveIngredientListOTC',
  'dateCode',
  'onlineLandingPageCheckProductIdentity',
  'onlineLandingPageCheckNetContents',
  'onlineLandingPageCheckIngredientList',
  'sealCheckPackagingIntegrity',
  'defectsPrintErrorsMisspellings',
];

const getCountryOfOriginValues = (physicalPackagingEvaluation) => {
  let countryOfOrigin = {};

  const keysOfCountryOfOrigin = Object.keys(physicalPackagingEvaluation).filter(
    (key) => key.includes('countryOfOrigin')
  );

  keysOfCountryOfOrigin.forEach((key) => {
    countryOfOrigin = {
      ...countryOfOrigin,
      [key]: {
        ...physicalPackagingEvaluation[key],
      },
    };
  });

  return countryOfOrigin;
};

export const orderNonFoodPhysicalPackaging = (physicalPackagingEvaluation) => {
  let result = {};

  if (!isEmpty(physicalPackagingEvaluation)) {
    const valueOfCountryOfOrigin = getCountryOfOriginValues(
      physicalPackagingEvaluation
    );

    nonFoodPhysicalPackaging.forEach((field) => {
      if (field === 'countryOfOrigin') {
        result = {
          ...result,
          ...valueOfCountryOfOrigin,
        };
      } else {
        result = {
          ...result,
          [field]: {
            ...physicalPackagingEvaluation[field],
          },
        };
      }
    });
  }

  return result;
};
